import { Route } from 'Common/appshell_types';

const routes: Record<Route, string> = {
    ALICE_CART: '/cart/index/',
    ALICE_CHECKOUT: '/checkout/index/',
    CART: '/shop/cart',
    CART_NATIVE: '/app/shop/cart',
    CHECKOUT: '/shop/checkout',
    CHECKOUT_NATIVE: '/app/shop/checkout',
    WISHLIST: '/web/wishlist',
    WISHLIST_NATIVE: '/app/wishlist',
    INTERIOR_DESIGN_SERVICE: '/m/interiorservice',
    INTERIOR_DESIGN_SERVICE_NATIVE: '/app/m/interiorservice',
    HALLO_WELT: '/hallo-welt',
    LOOKS: '/looks',
    SERVICE_PAGE: '/service-page',
};

export default routes;
